import createIcon from '../../createIcon';

/**
 * @component @name Mouse
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMS4wMzUxNlY4Ljk2NTE2SDIwQzIwIDQuODg1MTYgMTYuOTUgMS41MjUxNiAxMyAxLjAzNTE2Wk00IDE0Ljk2NTJDNCAxOS4zODUyIDcuNTggMjIuOTY1MiAxMiAyMi45NjUyQzE2LjQyIDIyLjk2NTIgMjAgMTkuMzg1MiAyMCAxNC45NjUyVjEwLjk2NTJINFYxNC45NjUyWk0xMSAxLjAzNTE2QzcuMDUgMS41MjUxNiA0IDQuODg1MTYgNCA4Ljk2NTE2SDExVjEuMDM1MTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Mouse = createIcon('Mouse', [
  [
    'path',
    {
      d: 'M13 1.03516V8.96516H20C20 4.88516 16.95 1.52516 13 1.03516ZM4 14.9652C4 19.3852 7.58 22.9652 12 22.9652C16.42 22.9652 20 19.3852 20 14.9652V10.9652H4V14.9652ZM11 1.03516C7.05 1.52516 4 4.88516 4 8.96516H11V1.03516Z',
      key: '5cqb0s',
    },
  ],
]);

export default Mouse;
